import { DataCondition, Dataset } from 'types';

import { getDataTypePrimaryEntityKey } from './data-type';

export const getConditions = (dataset: Dataset): DataCondition[] => {
    const { data_type, granularity } = dataset;

    const filterKey = getDataTypePrimaryEntityKey(data_type);
    const primaryEntityIds = granularity[filterKey];

    return primaryEntityIds.map((id: number) => ({
        data_type,
        primary_entity_id: id,
    }));
};
